export default __webpack_public_path__ + "static/media/Icon-Setting.db978030.svg";